import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import CardsLandingPage from '../../../pages/Cards/CardsLandingPage';
import CardsLandingMobile from '../../../pages/Mobile/Cards/CardsLandingMobile';

const CardsLandingResponsive: React.FC = () => {
  const { isMobile } = useResponsiveRedux();
  return isMobile ? <CardsLandingMobile /> : <CardsLandingPage />;
};

export default CardsLandingResponsive;
